import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import type { FileItem } from '@core/services/workflow/input-photos.types';
import { environment } from '@environment/environment';

@Pipe({
  name: 'fileUrl',
  standalone: true,
})
export class FileUrlPipe implements PipeTransform, OnDestroy {
  // Кэш по ссылке на File, а не на FileItem: FileItem пересоздаётся при
  // каждом изменении статуса (offline-очередь), а File внутри него
  // остаётся тем же — без кэша это плодило бы утечку object URL.
  private readonly objectUrlsByFile = new Map<File, string>();

  transform(fileItem: FileItem): string {
    if (fileItem.path) {
      return environment.staticUrl + fileItem.path;
    }

    if (fileItem.file) {
      return this.getOrCreateObjectUrl(fileItem.file);
    }

    return '';
  }

  ngOnDestroy(): void {
    for (const url of this.objectUrlsByFile.values()) {
      URL.revokeObjectURL(url);
    }

    this.objectUrlsByFile.clear();
  }

  private getOrCreateObjectUrl(file: File): string {
    const cachedUrl = this.objectUrlsByFile.get(file);

    if (cachedUrl) {
      return cachedUrl;
    }

    const url = URL.createObjectURL(file);

    this.objectUrlsByFile.set(file, url);

    return url;
  }
}
